<template>
  <v-container class="px-4 py-4" fluid>
    <v-row dense>
      <v-col cols="6">
        <InspLotQRCodeInput v-model="qrCode" @scanned="onAddItem" ref="txtQr" />
      </v-col>
      <v-spacer />
      <v-col>
        <Btn :label="$t('ELE0079')" @click="onClickSearchInspLot" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card-title>
          {{ $t('ELE0544') }}
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="items"
          :item-class="setRowClass"
          disable-pagination
          hide-default-footer
          dense
        >
          <template v-slot:[`item.action`]="{ index }">
            <IconDelete @click="onDeleteItem(index)" />
          </template>
          <template v-slot:[`item.manufacturerCompany`]="{ item }">
            {{ item.manufacturerCd }}: {{ item.manufacturerName }}
          </template>
          <template v-slot:[`item.part`]="{ item }"> {{ item.partCd }}: {{ item.partName }} </template>
          <template v-slot:[`item.error`]="{ item }">
            <div style="white-space: pre">{{ item.error }}</div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4">
        <CompanyInput
          :label="$t('ELE0005')"
          v-model="acceptCompanyCd"
          :companyCatCd="userCompanyCatCd"
          :disabled="companyDisabledComputed"
          validOnly
          required
        />
      </v-col>
      <v-col>
        <BtnSave @click="onClickSave" :disabled="disabledComputed" />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import DateUtil from '@/mixin/date-utils.js'
import { CompanyCatCd } from '@/enum.js'

import InspLotQRCodeInput from '@/components/atoms/text-field/InspLotQRCodeInput'
import Btn from '@/components/atoms/base/button/Btn'
import CompanyInput from '@/components/atoms/select/CompanyInput'
import BtnSave from '@/components/atoms/button/BtnSave'
import IconDelete from '@/components/atoms/icon/IconDelete.vue'

export default {
  name: 'ImpInspLotQRForm',

  mixins: [APIUtils, Message, Loading, DateUtil],

  components: {
    InspLotQRCodeInput,
    Btn,
    CompanyInput,
    BtnSave,
    IconDelete,
  },

  data() {
    return {
      qrCode: '',
      acceptCompanyCd: this.$store.getters.companyCd,
      userCompanyCatCd: this.$store.getters.companyCatCd,
      errorLineCount: '',
      items: [],
      headers: [
        { text: '', align: 'center', divider: true, sortable: false, value: 'action' },
        { text: this.$t('ELE0057'), value: 'manufacturerCompany', divider: true },
        { text: this.$t('ELE0059'), value: 'part', divider: true },
        { text: this.$t('ELE0049'), value: 'lotNo', divider: true },
        { text: this.$t('ELE0056'), value: 'refNo', divider: true },
        { text: this.$t('ELE0050'), value: 'qty', divider: true, align: 'end' },
        { text: this.$t('ELE0100'), value: 'error' },
      ],
    }
  },

  computed: {
    ...mapGetters(['userCd']),
    disabledComputed() {
      return !this.acceptCompanyCd || this.items.length === 0
    },
    companyDisabledComputed() {
      return this.userCompanyCatCd === CompanyCatCd.SUPPLIER
    },
  },

  methods: {
    onClickSearchInspLot() {
      this.$router.push({ name: 'T15' }).catch()
    },
    async onClickSave() {
      try {
        this.startLoading()
        const items = this.convertQRToJson(this.items)
        let body = {
          items: items,
          userCd: this.userCd,
        }
        const elements = await API.post('/box/checkInspBoxes', body)
        if (elements.isResult) {
          await this.registerBox(items)
        } else {
          this.errorLineCount = elements.errorLineCount
          elements.errorMessages.forEach((element) => {
            this.items[element.lineNo].error = element.bodies.join('\r\n')
          })
        }
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0003', { p0: this.$t('ELE0078') })))
      } finally {
        this.stopLoading()
      }
    },
    convertQRToJson(qrItems) {
      let items = []
      for (let index = 0; index <= qrItems.length - 1; index++) {
        let item = {}
        item.lotNo = qrItems[index].lotNo
        item.partCd = qrItems[index].partCd
        item.qty = qrItems[index].qty
        item.manufacturerCd = qrItems[index].manufacturerCd
        item.acceptCompanyCd = this.acceptCompanyCd
        item.acceptDatetime = qrItems[index].acceptDatetime
        item.remarks = ''
        item.refNo = qrItems[index].refNo
        item.everyKey = ''
        items.push(item)
      }
      return items
    },
    async registerBox(items) {
      try {
        let body = {
          items: items,
          userCd: this.userCd,
        }
        await API.post('/box/registerInspBoxes', body)
        this.setSuccessMessage(this.$t('MSG0041'))
        this.items = []
        this.$refs.txtQr.focus()
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0003', { p0: this.$t('ELE0078') })))
      }
    },
    onDeleteItem(index) {
      this.items.splice(index, 1)
    },
    onAddItem(inspIndexLotList) {
      for (let index = 0; index <= inspIndexLotList.length - 1; index++) {
        this.items.push(inspIndexLotList[index])
      }
    },
    setRowClass(item) {
      return item?.error ? 'cell-error' : ''
    },
  },
}
</script>
